import React, { useCallback, useMemo } from "react"
import { observer } from "mobx-react-lite"
import { useTheme } from '~/ui/styled'
// import { StartFlex, ColumnFlex, CenterFlex, BetweenFlex, Text, Button } from "~components/El"
import useNavigation from "~hooks/useNavigation"
import { FriendSentList as FriendSentListComponent } from "~components/friend-send-list"
import { useStores } from "~models"
import { Event, EventNames, FriendDeleteData, FLAG_ACK, FriendStatus, FriendCommonData } from "~proto"
import { globalToast } from "~utils"

const FriendSentList: React.FC = () => {
  const theme = useTheme()
  const navigation = useNavigation()
  const { userStore, eventStore, friendStore } = useStores()

  const onItemClick = useCallback((friend, action) => {
    if (action === 'APPROVE') {
      const user = userStore.users.get(`${friend.user_id}`)
      friend && friendStore.onRead(friend.id)
      const evt = new Event<FriendCommonData>(EventNames.FRIEND_APPROVE, {
        username: user.username,
      })
      eventStore.publish(evt, { flags: FLAG_ACK })
      navigation.navigate("ContactList")
      globalToast.show("已接受")
    } else if (action === 'REJECT') {
      const user = userStore.users.get(`${friend.user_id}`)
      if (!user?.username) {
        globalToast.show("用户不存在")
        return
      }
      friend && friendStore.onRead(friend.id)
      const evt = new Event<FriendCommonData>(EventNames.FRIEND_REJECT, {
        username: user.username,
      })
      eventStore.publish(evt, { flags: FLAG_ACK })
      navigation.navigate("ContactList")
      globalToast.show("已拒绝")
    }
   
    // navigation.push("PersonalCard", { userId: friend.user_id })
  }, [])

  const actionDelete = useCallback((friend) => {
    const evt = new Event<FriendDeleteData>(EventNames.FRIEND_DELETE, {
      id: friend.id,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
  }, [])

  const swipeActionButtonConfigs = useMemo(
    () => [
      {
        visible: (friend) => FriendStatus.PENDING === friend.status,
        icon: "trashCan",
        color: theme.colors.danger,
        text: "删除",
        onClick: actionDelete,
      },
    ],
    [],
  )
  return (
    <>
      <FriendSentListComponent
        sections={[...friendStore.friendSentListByStatus]}
        swipeActionButtonConfigs={swipeActionButtonConfigs}
        onItemClick={onItemClick}
      ></FriendSentListComponent>
    </>
  )
}

export default observer(FriendSentList)
